<!-- Loading State -->
@if (loading) {
<div class="relative w-full h-60">
  <ngx-skeleton-loader
    [theme]="{ width: '100%', height: '100%' }"
  ></ngx-skeleton-loader>
  <div class="absolute top-0 left-0 w-full flex justify-center">
    <ngx-skeleton-loader
      [theme]="{ width: '112px', height: '112px', 'border-radius': '50%' }"
    ></ngx-skeleton-loader>
  </div>
</div>
}

<!-- Restaurant Banner -->
@if (restaurantInfo && !loading) {
<div
  class="relative w-full bg-cover bg-center h-60"
  [style.background-image]="
    'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1)), url(' +
    getImageUrl(restaurantInfo.picture_establishment, 'si') +
    ')'
  "
>
  <!-- Restaurant Logo Circle -->
  <div class="absolute top-0 left-0 w-full flex justify-center">
    <div
      class="mt-8 sm:mt-10 md:mt-8 w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full overflow-hidden border-4 border-amber-400 shadow-lg"
    >
      <img
        [src]="getImageUrl(restaurantInfo.picture_logo)"
        alt="Restaurant Logo"
        class="w-full h-full object-cover"
        (error)="onImageError($event)"
      />
    </div>
  </div>
  <div
    class="absolute inset-0 flex flex-col justify-end p-6 pt-52 sm:pt-48 md:pt-40 lg:pt-32 text-white"
  >
    <!-- Restaurant Name and Rating -->
    <div
      class="flex flex-col md:flex-row md:items-center md:justify-between mb-2"
    >
      <h1 class="text-3xl md:text-4xl font-bold">
        {{ restaurantInfo.name_restaurant }}
      </h1>
    </div>
    <!-- Description -->
    <!-- <p class="text-gray-200 mb-4">Authentic Italian cuisine in the heart of the city. We pride ourselves on using only the freshest ingredients and traditional recipes passed down through generations.</p> -->
    <!-- Contact Info and Hours -->
    <div
      class="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-6"
    >
      <!-- Address -->
      <div class="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 mr-2 text-amber-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        <span>{{ restaurantInfo.address }}</span>
      </div>
      <!-- Phone -->
      <div class="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 mr-2 text-amber-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
        <span>{{ restaurantInfo.phone || "+1 (555) 123-4567" }}</span>
      </div>
      <!-- Hours -->
      <div class="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 mr-2 text-amber-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>{{ restaurantInfo.apertura }} - {{ restaurantInfo.cierre }}</span>
      </div>
      <!-- Open Status -->
      <div class="flex items-center">
        <div [appIsOpen]="isOpen()"></div>
      </div>
    </div>
  </div>
</div>
}
